<template>
  <vs-prompt buttons-hidden title="Add Note" :active="showAddUserNote" @close="close">
    <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>
    <vs-alert title="" :active="error" color="danger">Wasn't able to add note to user!</vs-alert>
    <div class="vx-row mb-1" >
      <div class="vx-col  w-full">
        <vs-textarea
          class="w-full my-2"
          label="Note"
          v-model="note.message"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full my-2">
        <vs-button class="float-right" color="primary" type="border" icon-after icon="add" @click="addNote">Add Note</vs-button>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
import api from "@/http/api";

export default {
  props: [
    'userId',
    'showAddUserNote',
    'fetchUser'
  ],
  data() {
    return {
      note: {
        message: '',
        eventType: 'general'
      },
      loading: false,
      error: false,
    }
  },
  methods: {
    async addNote() {
      this.loading = true;
      this.error = false;
      let addedNote = false;

      if (this.note.message.length && this.userId) {
        addedNote = await api.addUserNote(this.userId, this.note);
      }

      this.loading = false;
      if(!addedNote) return this.error = true;

      this.fetchUser();
      this.close();
    },
    close() {
      this.error = false;
      this.note = {
        message: '',
        eventType: 'general'
      };
      this.$emit('update:showAddUserNote', false);
    },
  }
}
</script>
